var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Setup-guide-steps",
    transform: "translate(-145.000000, -189.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-video-thumbnail",
    transform: "translate(145.000000, 189.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,0 L1,0 C0.44771525,1.01453063e-16 -6.76353751e-17,0.44771525 0,1 L0,13 C6.76353751e-17,13.5522847 0.44771525,14 1,14 L17,14 C17.5522847,14 18,13.5522847 18,13 L18,1 C18,0.44771525 17.5522847,-1.01453063e-16 17,0 Z M8.14285714,11.375 L9.85714286,11.375 L9.85714286,13.125 L8.14285714,13.125 L8.14285714,11.375 Z M11.5714286,11.375 L13.2857143,11.375 L13.2857143,13.125 L11.5714286,13.125 L11.5714286,11.375 Z M15,11.375 L16.7142857,11.375 L16.7142857,13.125 L15,13.125 L15,11.375 Z M4.71428571,11.375 L6.42857143,11.375 L6.42857143,13.125 L4.71428571,13.125 L4.71428571,11.375 Z M1.28571429,11.375 L3,11.375 L3,13.125 L1.28571429,13.125 L1.28571429,11.375 Z M8.14285714,0.875 L9.85714286,0.875 L9.85714286,2.625 L8.14285714,2.625 L8.14285714,0.875 Z M11.5714286,0.875 L13.2857143,0.875 L13.2857143,2.625 L11.5714286,2.625 L11.5714286,0.875 Z M15,0.875 L16.7142857,0.875 L16.7142857,2.625 L15,2.625 L15,0.875 Z M4.71428571,0.875 L6.42857143,0.875 L6.42857143,2.625 L4.71428571,2.625 L4.71428571,0.875 Z M1.28571429,0.875 L3,0.875 L3,2.625 L1.28571429,2.625 L1.28571429,0.875 Z",
    id: "Shape",
    fill: "#6F7FE2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C7CEF9",
    points: "7.71428571 4.375 7.71428571 9.625 12 7.2279375"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoThumbnail);
export default __webpack_public_path__ + "static/media/icon-video-thumbnail.acaf1d6088ac21341d18d2eb5139b9f9.svg";
export { ForwardRef as ReactComponent };